import React from "react";
import SearchIcon from "../../assets/icons/search.svg2";
import { func } from "prop-types";

export default function MySearch({ value, onChange, placeholder }) {
  return (
    <div className="position-relative">
      <div
        className="top-50 end-0 translate-middle bg-colored text-white rounded-pill position-absolute text-center ms-2"
        style={{ width: 25, height: 25 }}
      >
        <SearchIcon width={12} heigth={12} className="white" />
      </div>
      <input
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className="form-control text-black text-nowrap pe-5 ps-2 py-2 rounded-3 w-100 "
        style={{ fontSize: "1rem" }}
        type="text"
      />
    </div>
  );
}

export function MyDebouncedSearch({ value, onChange, placeholder }) {
  const [searchTerm, setSearchTerm] = React.useState(value);

  React.useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      onChange(searchTerm);
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [searchTerm]);

  return (
    <MySearch
      value={searchTerm}
      onChange={(e) => setSearchTerm(e.target.value)}
      placeholder={placeholder}
    />
  );
}

